<template>
  <v-container>
    <v-card elevation="0">
      <v-card-title>Opciones de vehiculos
        <v-spacer />
        <v-btn text color="primary" @click="processVehicules">procesar vinculo</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-if="loadingData">
          <v-col class="d-flex justify-center">
            <v-progress-circular color="primary" indeterminate width="2" size="60" />
          </v-col>
        </v-row>
        <v-row v-if="loadedData">
          <v-col>
            <v-card outlined>
              <v-card-title>
                <v-icon class="mr-2">mdi-car-key</v-icon>
                Vehiculos asignados ({{ vehiculesAssigned.length }})
                <v-spacer />
                <v-btn icon @click="showListAssigned = !showListAssigned">
                  <v-icon>
                    {{
          showListAssigned ? "mdi-chevron-up" : "mdi-chevron-down"
        }}
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="showListAssigned">
                  <v-card-text>
                    <v-list>
                      <template v-for="(vehicule, key) in vehiculesAssigned">
                        <v-list-item :key="key" v-if="vehiculesAssigned" @click="releaseVehicule(vehicule)">
                          <v-list-item-avatar size="40">
                            <v-img :src="vehicule.photo_1" :lazy-src="vehicule.photo_1_thumb" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title><b>
                                {{ vehicule.plate }}
                              </b>
                            </v-list-item-title>
                            <v-list-item-subtitle>{{
          vehicule.model
        }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="`div${key}`" v-if="key != vehiculesAssigned.length - 1" />
                      </template>
                    </v-list>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>

            <v-card outlined class="mt-5">
              <v-card-title>
                <v-icon class="mr-2">mdi-car</v-icon>
                Vehiculos disponibles ({{ vehiculesAvailable.length }})
                <v-spacer />
                <v-btn icon @click="showListAvailable = !showListAvailable">
                  <v-icon>
                    {{ showListAvailable ? "mdi-chevron-up" : "mdi-chevron-down" }}
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-expand-transition>
                <div v-show="showListAvailable">
                  <v-card-text>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar vehiculo" single-line
                      hide-details style="max-width: 400px" class="mb-5"></v-text-field>

                    <v-data-table :search="search" :headers="headers" :items="vehiculesAvailable" :items-per-page="10"
                      :mobile-breakpoint="800" @click:row="assingVehicule">
                      <template v-slot:[`item.name`]="{ item }">
                        <v-avatar size="40" v-if="item.photo_1">
                          <v-img :src="item.photo_1" :lazy-src="item.photo_1_thumb" />
                        </v-avatar>
                      </template>

                      <template v-slot:[`item.type`]="{ item }">
                        {{ item.type == "car" ? "CARRO / CAMIONETA" : "MOTO" }}
                      </template>

                      <template v-slot:[`item.location`]="{ item }">
                        {{ item.location ? item.location.name : "" }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import photoEmpty from "../../assets/profile.jpeg";

export default {
  props: ["click", "employeeId", "schema"],

  mounted() {
    this.loadVehicules();
  },

  data() {
    return {
      loadingData: true,
      loadedData: false,
      employeeIdAux: 0,
      photoEmpty: photoEmpty,
      showListAssigned: true,
      showListAvailable: false,
      vehicules: [],
      search: "",
      headers: [
        {
          text: "Foto",
          value: "name",
          width: "10%",
        },
        {
          text: "Placa",
          value: "plate",
          width: "20%",
        },
        {
          text: "Ubicacion",
          value: "location.name",
          width: "20%",
        },
        {
          text: "Modelo",
          aling: "left",
          value: "model",
          width: "20%",
        },
        {
          text: "Tipo",
          aling: "center",
          value: "type",
          width: "30%",
        },
      ],
    };
  },

  watch: {
    click() {
      this.showListAvailable = false;
      this.showListAssigned = true;
      if ((this.employeeId != this.employeeIdAux) || this.schema == "new") {
        this.employeeIdAux = this.employeeId;
        this.vehicules = [];
        this.loadVehicules();
      }
    },
  },

  computed: {
    vehiculesAssigned() {
      if (this.vehicules.length) {
        let vehiculesAssigned = [];
        this.vehicules.forEach(element => {
          if (this.schema == "edit") {
            if (element.employee_id == -1) {
              vehiculesAssigned.push(element);
            } else if (element.employee_id == this.employeeId) {
              vehiculesAssigned.push(element);
            }
          } else {
            if (element.employee_id == -1)
              vehiculesAssigned.push(element)
          }
        });
        return vehiculesAssigned;
      }
      return [];
    },

    vehiculesAvailable() {
      if (this.vehicules.length) {
        let va = this.vehicules.filter((v) => v.employee_id == 0);
        return va;
      }
      return [];
    },
  },

  methods: {
    loadVehicules() {
      this.loadingData = true;
      this.loadedData = false;
      this.vehiculeIds = "";

      setTimeout(() => {
        this.$store.dispatch("findVehiculesAction").then((res) => {
          this.vehicules = res;

          this.loadingData = false;
          this.loadedData = true;
        });
      }, 500);
    },

    assingVehicule(value) {
      let index = this.vehicules.findIndex((v) => v.id == value.id);
      this.vehicules[index].employee_id = -1;
    },

    releaseVehicule(value) {
      let index = this.vehicules.findIndex((v) => v.id == value.id);
      this.vehicules[index].employee_id = 0;
    },

    processVehicules() {
      let vehiculeIds = "";

      this.vehiculesAssigned.forEach((element) => {
        vehiculeIds += element.id + ",";
      });

      vehiculeIds += "0";

      this.$emit("vehiculesIds", vehiculeIds);
    },
  },
};
</script>
